<div
  class="input-container"
  [style.--font-size]="fontSize"
  [style.--text-color]="textColor"
  [style.--placeholder-font-size]="placeholderFontSize || fontSize"
  [style.--placeholder-color]="placeholderColor"
  [style.--background-color]="backgroundColor"
  [style.--border-color]="borderColor"
  [style.--focus-border-color]="focusBorderColor"
  [style.--focus-background-color]="focusBackgroundColor"
  [style.--suffix-color]="suffixColor"
  [style.--suffix-background-color]="suffixBackgroundColor"
  [style.--border-radius]="borderRadius"
  [style.--height]="height"
>
  <div class="input-wrapper">
    <input
      [style.font-weight]="fontWeight"
      [type]="type"
      [formControl]="control"
      [placeholder]="placeholder"
      [maxlength]="maxlength"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <label [class.float]="shouldFloat">
      {{ placeholder }}
    </label>
  </div>

  <div class="suffix" *ngIf="suffix" [class.suffix-focused]="isFocused">
    <span>{{ suffix }}</span>
  </div>
</div>
